import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { CommonErrorCode, DataRoleErrorCode } from '~commonInfra/utils/ErrorCodes';
import { ContentUrlForItem } from '~src/spacesPlatform/services/ContentUrl';

import { Messages } from '../../codegen/Localize';
import { L10n } from '../../commonInfra/L10n/L10n';
import { DataRoleContentType } from '../../spacesPlatform/models/ContentTypes';
import { IDataRoleBase } from '../models/IDataRoleInfo';

export class DataRoleErrors {
  public static errorDetailsFor(dataRoleErrorItem: IErrorItem<IDataRoleBase>): IErrorDetail {
    return {
      itemName: dataRoleErrorItem.item.name,
      itemUrl:
      dataRoleErrorItem.error.code === CommonErrorCode.DataRoleNotFound
          ? null
          : ContentUrlForItem(dataRoleErrorItem.item, DataRoleContentType),
      errorMessage: DataRoleErrors.errorMessageFor(dataRoleErrorItem)
    };
  }

  public static errorMessageFor(errorItem: IErrorItem<IDataRoleBase>) {
    const dataRole = errorItem.item;
    switch (errorItem.error.code) {
      case CommonErrorCode.DataRoleNotFound:
        return Messages.errorDataRoleNotFound({ DATA_ROLE_NAME: L10n.elideIfLong(dataRole.name) });
      case DataRoleErrorCode.DataRoleWithSameNameInDestinationProject:
        return Messages.errorDataRoleNameAlreadyExists();
      case DataRoleErrorCode.DataRoleDestinationProjectNotFound:
        return Messages.errorDataRoleDestinationProjectNotFound();
      case CommonErrorCode.CallingUserInsufficientPermissions:
      case DataRoleErrorCode.DataRoleMoveInsufficientPermissionsOnDestinationProject:
        return Messages.errorDataRoleInsufficientPermissions();
      default:
        return Messages.errorUnknown();
    }
  }
}
